import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

export default function WebQuestionButton({
	url,
	title = "Next",
	handleClick = () => {},
	loading = false,
	loadingMessage = "Next",
}) {
	const navigate = useNavigate();
	const location = useLocation();
	const publicUrl = process.env.PUBLIC_URL;

	const handleProceed = () => {
		handleClick();
		if (url) return navigate(`${publicUrl}${url}${location?.search || ""}`);
	};

	return (
		<React.Fragment>
            <button
                style={{
                    cursor: loading ? "auto" : "pointer",
                    position: "absolute",
                    width: loading ? "180px" : "120px",
                    height: "45px",
                    bottom: "35px",
                    right: "10px",
                    display: "inline-block",
                    border: "none",
                    outline: "none",
                    textDecoration: "none",
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    transition: "bottom 0.3s",
                    backgroundColor: loading ? "#879a9a" : "#0e9595",
                    borderBottom: loading ? "2px solid #879a9a" : "2px solid #0e9595",
                }}
                disabled={loading}
                onClick={handleProceed}
            >
                <Box component="span"
                    sx={{
                        fontWeight: "bold",
                        fontSize: "2em",
                        color: "white",
                        textAlign: "center",
                        "@media (max-width: 1024px), (max-height: 768px)": {
                            fontSize: "1.5em",
                        },
                        "@media (max-width: 800px), (max-height: 600px)": {
                            fontSize: "1.5em",
                        },
                    }}
                >{loading ? loadingMessage : title}</Box>
            </button>
		</React.Fragment>
	);
}